


export default function Title2({title}){
    return(
        <p
        className="text-base font-bold text-black222 text-left
            || mt-c28 mb-c16   "
      >
        {title}
      </p>
    )
}